import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column justify-center align-center",
  style: {"min-height":"50vh"}
}
const _hoisted_2 = {
  key: 1,
  class: "bg-light"
}
const _hoisted_3 = { class: "container my-4" }
const _hoisted_4 = { class: "row justify-content-center" }
const _hoisted_5 = { class: "col-12 col-md-10 col-lg-8" }
const _hoisted_6 = { class: "card mb-4" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "bg-light p-4 rounded" }
const _hoisted_9 = { class: "mb-4" }
const _hoisted_10 = { class: "mb-0" }
const _hoisted_11 = { class: "mb-0" }
const _hoisted_12 = { class: "d-flex flex-column flex-sm-row justify-content-between gap-3" }

import { ref, computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import Subscription, { StripeInvoice } from '../../../../../api/v2/models/subscription'
import { subscriptionState } from '../../../../stores/subscription'
import PremiumService from '../../../../../api/v2/models/pre_service'
import { userState } from '../../../../stores/user'
import { calcTaxIncluded } from '../../../../utils/price'
import { getQueryString } from '../../../../../../helpers/route-helper'

// Router

export default /*@__PURE__*/_defineComponent({
  __name: 'Completion',
  setup(__props) {

const route = useRoute()

// Reactive state
const subscription = ref<Subscription | null>(null)
const stripeLastInvoice = ref<StripeInvoice | null>(null)
const targetPremiumService = ref<PremiumService | null>(null)
const isLoading = ref(true)

// Computed properties
const targetPremiumServiceIdQuery = computed((): string | null => {
  return getQueryString(route.query, 'targetPremiumServiceId')
})

// Methods
const getSubscription = () => {
  subscriptionState.getSubscription(route.params.subscriptionId as any).then((response) => {
    if (response) {
      subscription.value = response.subscription
      stripeLastInvoice.value = response.stripeInvoices[0]
    }
  })
}

const getTargetPremiumService = () => {
  subscriptionState.getTargetPremiumService(route.params.subscriptionId as any, targetPremiumServiceIdQuery.value as any).then((response) => {
    if (response) {
      targetPremiumService.value = response
      isLoading.value = false
    }
  })
}

const localNumber = (number: number) => {
  return new Intl.NumberFormat("ja-JP").format(number)
}

// Lifecycle
onMounted(() => {
  getSubscription()
  getTargetPremiumService()
  userState.getUser()
})

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_router_link = _resolveComponent("router-link")!

  return (isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_progress_circular, {
          indeterminate: "",
          color: "green",
          size: "48"
        }),
        _cache[0] || (_cache[0] = _createElementVNode("p", { class: "mt-4" }, "データを読み込んでいます。しばらくお待ちください...", -1 /* CACHED */))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _cache[10] || (_cache[10] = _createStaticVNode("<div class=\"progress rounded-0\" data-v-1d088a06><div class=\"progress-bar bg-primary\" style=\"width:100%;\" data-v-1d088a06></div></div><div class=\"container mt-4\" data-v-1d088a06><div class=\"row justify-content-center\" data-v-1d088a06><div class=\"col-12 col-md-10 col-lg-8\" data-v-1d088a06><div class=\"d-flex justify-content-between\" data-v-1d088a06><div class=\"progress-step text-center\" data-v-1d088a06><div class=\"step-circle step-circle-complete mx-auto\" data-v-1d088a06></div><small class=\"d-block mt-2 text-primary\" data-v-1d088a06>プランの確認</small></div><div class=\"progress-step text-center\" data-v-1d088a06><div class=\"step-circle step-circle-complete mx-auto\" data-v-1d088a06></div><small class=\"d-block mt-2 text-primary\" data-v-1d088a06>お支払い</small></div><div class=\"progress-step text-center\" data-v-1d088a06><div class=\"step-circle step-circle-complete mx-auto\" data-v-1d088a06></div><small class=\"d-block mt-2 progress-step-active\" data-v-1d088a06>完了</small></div></div></div></div></div>", 2)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"card mb-4 animate-fadeInUp\" data-v-1d088a06><div class=\"card-body text-center py-5\" data-v-1d088a06><div class=\"success-icon-bg mx-auto mb-4\" data-v-1d088a06><div class=\"success-icon\" data-v-1d088a06><i class=\"bi bi-check-lg\" data-v-1d088a06></i></div></div><h2 class=\"h4 fw-bold mb-3\" data-v-1d088a06>プラン変更が完了しました</h2><p class=\"text-secondary mb-0\" data-v-1d088a06>確認メールをお送りしました</p><p class=\"text-secondary small\" data-v-1d088a06>メールが届かない場合はスパムフォルダをご確認ください</p></div></div>", 1)),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "h6 fw-bold mb-4" }, "変更内容のご確認", -1 /* CACHED */)),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _cache[1] || (_cache[1] = _createElementVNode("label", { class: "text-secondary small d-block mb-1" }, "変更前", -1 /* CACHED */)),
                      _createElementVNode("p", _hoisted_10, _toDisplayString(subscription.value.premiumServiceName) + "（¥" + _toDisplayString(localNumber(_unref(calcTaxIncluded)(subscription.value && subscription.value.premiumServicePrice ? subscription.value.premiumServicePrice : 0))) + "/月）", 1 /* TEXT */)
                    ]),
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "d-flex align-items-center mb-4" }, [
                      _createElementVNode("i", { class: "bi bi-arrow-down text-secondary" })
                    ], -1 /* CACHED */)),
                    _createElementVNode("div", null, [
                      _cache[2] || (_cache[2] = _createElementVNode("label", { class: "text-secondary small d-block mb-1" }, "変更後", -1 /* CACHED */)),
                      _createElementVNode("p", _hoisted_11, _toDisplayString(targetPremiumService.value.name) + "（¥" + _toDisplayString(localNumber(targetPremiumService.value.price)) + "/月）", 1 /* TEXT */)
                    ])
                  ])
                ])
              ]),
              _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"card next-steps mb-4\" data-v-1d088a06><div class=\"card-body\" data-v-1d088a06><h2 class=\"h6 fw-bold mb-3\" data-v-1d088a06>次のステップ</h2><div class=\"d-flex align-items-start mb-2\" data-v-1d088a06><i class=\"bi bi-journal-text next-steps-icon me-3\" data-v-1d088a06></i><p class=\"mb-0\" data-v-1d088a06>新しいコースが利用可能になりました</p></div><div class=\"d-flex align-items-start\" data-v-1d088a06><i class=\"bi bi-play-circle next-steps-icon me-3\" data-v-1d088a06></i><p class=\"mb-0\" data-v-1d088a06>マイページから学習を開始できます</p></div></div></div>", 1)),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_router_link, {
                  to: `/classroom`,
                  class: "btn btn-light border order-2 order-sm-1"
                }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode(" マイページへ戻る ", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_router_link, {
                  to: `/classroom`,
                  class: "btn btn-primary order-1 order-sm-2 text-white"
                }, {
                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                    _createTextVNode(" 学習を始める ", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                })
              ]),
              _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-secondary small text-center mt-4" }, " ご不明な点がございましたら、お気軽にお問い合わせください ", -1 /* CACHED */))
            ])
          ])
        ])
      ]))
}
}

})